import { Close } from '@mui/icons-material';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export const PrivacyAgreementDialog: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle className="flex! items-center justify-between">
        [필수] 개인정보 수집 및 이용 동의
        <IconButton aria-label="close" onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText className="pb-6">
          회사는 본 웹사이트를 통해 계정/Lenovo ID 가입 및 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.
        </DialogContentText>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>수집 항목</TableCell>
                <TableCell>수집 목적</TableCell>
                <TableCell>보유 기간</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell>이메일 주소(ID), 비밀번호, 이름</TableCell>
                <TableCell>서비스 가입 및 사용자 식별, 계정/Lenovo ID 관리, 공지사항 전달</TableCell>
                <TableCell className="underline">회원 탈퇴 시 삭제</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <DialogContentText className="pt-6">
          ※ 위에서 설명한 대로 개인 정보 수집 및 사용에 대한 동의를 거부할 수 있으나, 동의를 거부하는 경우 계정/Lenovo
          ID 서비스를 이용할 수 없습니다.
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
